import { RecurrencyRole, TenantProductName, TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { TenantDTO } from '@recurrency/core-api-schema/dist/tenants/tenantDTO';

import type { ExtendedUser } from 'hooks/useGlobalApp';

import { arePermissionsEnabled, hasUserPermission, isRecurrencyRole, shouldShowProduct } from 'utils/roleAndTenant';

/**
 * Single source of truth for who can use "Chat with your data". Referenced by the
 * page route guard (AppRoutes), the app-shell chat launcher (App), nav, and the
 * header button so access can't drift between them.
 *
 * Allow if:
 * - Auth0 `recurrency:staff:user` (demo / support bypass), or
 * - tenant has chatWithData productEnabled AND the user is entitled: by the Chat with Data permission
 *   once the tenant gates by permission, by RecurrencyRole.ChatWithData until then
 */
export function hasChatWithDataAccess(activeTenant: TenantDTO, activeUser: ExtendedUser): boolean {
  if (activeUser.isStaffUser) {
    return true;
  }

  return (
    shouldShowProduct(activeTenant, TenantProductName.ChatWithData) &&
    (arePermissionsEnabled()
      ? hasUserPermission(activeTenant, TenantUserPermission.AccessChatDataView)
      : isRecurrencyRole(activeTenant, RecurrencyRole.ChatWithData))
  );
}
